import {useState} from "react";
import {Review} from "@/entities/product";
import type {ReviewsType, ExpandedState} from "../model/types";

type UseProductReviewsResult = {
    type: ReviewsType;
    totalCountOfReviews: number;
    visibleReviews: Review[];
    reviewsWithImages: Review[];
    showMore: () => void;
    toggleExpand: (id: number) => void;
    expanded: ExpandedState;
    changeType: (type: ReviewsType) => void;
    hasMore: boolean;
};

export const useProductReviews = (reviews: Review[] = []): UseProductReviewsResult => {
    const [type, setType] = useState<ReviewsType>("all");
    const [visibleCount, setVisibleCount] = useState<number>(2);
    const [expanded, setExpanded] = useState<ExpandedState>({});

    const totalCountOfReviews = reviews.length;

    const reviewsWithImages = reviews.filter(review => Boolean(review.img));

    const currentReviews = type === "all" ? reviews : reviewsWithImages;

    const visibleReviews = currentReviews.slice(0, visibleCount);

    const toggleExpand = (id: number) => {
        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const showMore = () => {
        setVisibleCount(prev => prev + 5);
    };

    const changeType = (newType: ReviewsType) => {
        if (newType === type) {
            return;
        }

        setType(newType);
        setVisibleCount(2);
    };

    return {
        type,
        totalCountOfReviews,
        visibleReviews,
        reviewsWithImages,
        showMore,
        toggleExpand,
        expanded,
        changeType,
        hasMore: currentReviews.length > visibleCount,
    };
};
